import { fakeLogin } from './_config/fakeLogin';
import redirectPages from './_config/redirectPages';
import * as contentText from './_data/contentText';
import { contentExtras } from './_data/contentExtras';
import contentMappingTransfer from './_data/contentMappingTransfer';

export const Content = {
    fakeLogin: fakeLogin,
    redirectPages: redirectPages,
    loadingOffersText: contentText.loadingOffersText,
    errorText: contentText.errorText,
    errorPaymentText: contentText.errorPaymentText,
    errorNoOffersText: contentText.errorNoOffersText,
    extras: contentExtras,
    mappingTransfer: contentMappingTransfer,
};
export default Content;
